import { SidebarProvider } from '@neo/primitives/sidebar'
import { useMemo } from 'react'
import { UserRole } from 'v2/types/api/auth'
import { getSessionRoles } from 'v2/utils'

type SidebarProviderWrapperProps = React.ComponentProps<typeof SidebarProvider>

/**
 * Wrapper around SidebarProvider that sets defaultOpen based on user role.
 * Agent-only users (single role = agent) get collapsed sidebar by default.
 */
export const SidebarProviderWrapper = ({ defaultOpen, ...props }: SidebarProviderWrapperProps) => {
  const computedDefaultOpen = useMemo(() => {
    // If explicitly provided, use that value
    if (defaultOpen !== undefined) return defaultOpen

    // Agent-only users get collapsed sidebar by default
    const roles = getSessionRoles()
    const isAgentOnly = roles.includes(UserRole.agent) && roles.length === 1
    return !isAgentOnly
  }, [defaultOpen])

  return <SidebarProvider defaultOpen={computedDefaultOpen} {...props} />
}
